import React from 'react';
import { AppButton, Box } from '@common-fe/common-fe';

interface ForgotPasswordSuccessProps {
  onNext: (value?: object) => void;
}

const ForgotPasswordSuccess: React.FC<ForgotPasswordSuccessProps> = ({ onNext }) => (
  <Box margin={{ top: '-8px' }}>
    <AppButton
      testId="forgot-password-continue"
      type="submit"
      width="100%"
      size="L"
      onClick={onNext}
    >
      Sign In
    </AppButton>
  </Box>
);

export default ForgotPasswordSuccess;
